export class FrontFaceId {

    public Index: number = 0;
    public IsPlinth: boolean = false;

    public equals(other: FrontFaceId): boolean {
        return other !== null && other.Index === this.Index && other.IsPlinth === this.IsPlinth;
    }
}
